module.exports = __webpack_public_path__ + "img/helmet.e7bc7859.png";